// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height[data-v-6ac9aac2] {\n  position: relative;\n  height: 100%;\n}\n.el-dialog__body[data-v-6ac9aac2] {\n  padding-top: 0px;\n}\n.currency-select .el-tag.el-tag--info[data-v-6ac9aac2] {\n  background-color: green !important;\n  border-color: black !important;\n  color: white !important;\n  font-size: 17px !important;\n  height: 30px !important;\n}\n[data-v-6ac9aac2] :disabled {\n  color: blue !important;\n}\n", ""]);
// Exports
module.exports = exports;
